import { Col, DatePicker, Input } from "antd";
import { Form } from "antd";
import { Row } from "antd";
import React, { FC } from "react";

type HospitalBillDetailsProps = {
  claimData?: any;
}

const HospitalBillDetails: FC<HospitalBillDetailsProps> = ({
  claimData,
}) => {
  const dateFormat = "DD-MM-YYYY HH:mm:ss";
  return (
    <>
      <h3>Hospital Bill Details</h3>

      <Row gutter={[16, 16]}>
        <Col span={8}>
          <Form.Item label="Hospital Bill Number" name="billNumber">
            <Input
              style={{ width: "100%" }}
              placeholder="Enter Hospital Bill Number"
              min={0}
              disabled={claimData?.submitted}
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="Date" name="billDate">
            <DatePicker
              allowClear
              style={{ width: "100%" }}
              showTime
              format={dateFormat}
              disabled={claimData?.submitted}
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="Hospital Bill Amount" name="billAmount">
            <Input
              style={{ width: "100%" }}
              placeholder="Enter Hospital Bill Amount"
              min={0}
              disabled={claimData?.submitted}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default HospitalBillDetails;
